/**
 * 菜单功能按钮的国际化
 * date：2022 04 25
 */
export default {
  func: {
    viewIncubator: '查看保温箱',
    newIncubator: '新增保温箱',
    editIncubator: '编辑保温箱',
    relatedIncubator: '探测设备关联保温箱',
    removeIncubator: '删除保温箱',
    viewIncubatorOperate: '查看保温箱操作记录',
    removeIncubatorOperate: '删除保温箱操作记录',
    viewIncubatorCollect: '查看保温箱数据采集设置',
    applyIncubatorCollect: '应用保温箱数据采集设置',
    removeIncubatorCollect: '删除保温箱数据采集设置',
    viewFridge: '查看冰箱',
    newFridge: '新增冰箱',
    editFridge: '编辑冰箱',
    relatedFridge: '探测设备关联冰箱',
    removeFridge: '删除冰箱',
    viewFridgeOperate: '查看冰箱操作记录',
    removeFridgeOperate: '删除冰箱操作记录',
    viewFridgeCollect: '查看冰箱数据采集设置',
    applyFridgeCollect: '应用冰箱数据采集设置',
    removeFridgeCollect: '删除冰箱数据采集设置',
    viewCar: '查看车辆',
    newCar: '新增车辆',
    editCar: '编辑车辆',
    relatedCar: '探测设备关联车辆',
    removeCar: '删除车辆',
    viewCarOperate: '查看车辆操作记录',
    removeCarOperate: '删除车辆操作记录',
    viewCarCollect: '查看车辆数据采集设置',
    applyCarCollect: '应用车辆数据采集设置',
    removeCarCollect: '删除车辆数据采集设置',
    viewRefrigeratory: '查看冷库',
    newRefrigeratory: '新增冷库',
    editRefrigeratory: '编辑冷库',
    relatedRefrigeratory: '探测设备关联冷库',
    removeRefrigeratory: '删除冷库',
    viewRefrigeratoryOperate: '查看冷库操作记录',
    removeRefrigeratoryOperate: '删除冷库操作记录',
    viewRefrigeratoryCollect: '查看冷库数据采集设置',
    applyRefrigeratoryCollect: '应用冷库数据采集设置',
    removeRefrigeratoryCollect: '删除冷库数据采集设置',
    viewEx: '查看异常记录',
    handleEx: '处理异常记录',
    removeEx: '删除异常记录',
    viewExReason: '查看异常原因',
    newExReason: '新增异常原因',
    editExReason: '编辑异常原因',
    removeExReason: '删除异常原因',
    viewCustomer: '查看客户',
    newCustomer: '新增客户',
    editCustomer: '编辑客户',
    removeCustomer: '删除客户',
    viewRole: '查看角色',
    newRole: '新增角色',
    editRole: '编辑角色',
    removeRole: '删除角色',
    viewUser: '查看用户',
    newUser: '新增用户',
    editUser: '编辑用户',
    removeUser: '删除用户',
    viewVoiceNoticeLog: '查看语音日志',
    viewMessageNoticeLog: '查看短信日志',
    viewEmailNoticeLog: '查看邮件日志',
    removeVoiceNoticeLog: '删除语音日志',
    removeMessageNoticeLog: '删除短信日志',
    removeEmailNoticeLog: '删除邮件日志',
    viewScene: '查看组织架构',
    viewHistory: '历史数据查询',
    modifyScene: '编辑组织架构',
    viewInstance: '查看探测设备数据',
    viewGridMonitor: '查看列表数据',
    viewDataMonitor: '查看地图数据',
    viewProbeUnit: '查看计量单位',
    newProbeUnit: '新增计量单位',
    editProbeUnit: '编辑计量单位',
    deleteProbeUnit: '删除计量单位',
    viewParam: '查看参数',
    newParam: '新增参数',
    editParam: '编辑参数',
    deleteParam: '删除参数',
    viewProbeRange: '查看监测区间',
    newProbeRange: '新增监测区间',
    editProbeRange: '编辑监测区间',
    deleteProbeRange: '删除监测区间',
    viewForwardSet: '查看转发设置',
    newForwardSet: '新增转发设置',
    editForwardSet: '编辑转发设置',
    deleteForwardSet: '删除转发设置',
    viewUrlPage: '查看访问资源',
    newUrlPage: '新增访问资源',
    editUrlPage: '编辑访问资源',
    deleteUrlPage: '删除访问资源',
    viewRecordPoint: '查看采集数据',
    exportRecordPoint: '导出采集数据',
    editRecordPoint: '编辑采集数据',
    deleteRecordPoint: '删除采集数据',
    viewCarrierRecordSet: '查看资产采集数据设置',
    editCarrierRecordSet: '编辑资产采集数据设置',
    viewSysLog: '查看系统日志',
    deleteSysLog: '删除系统日志',
    setSysLog: '触发系统日志设置',
    viewContacts: '查看联系人',
    newContacts: '新增联系人',
    editContacts: '编辑联系人',
    deleteContacts: '删除联系人',
    contactsSync: '同步联系人',
    viewDisplay: '查看显示屏',
    applyDisplayAppConfig: '配置显示屏应用参数',
    applyDisplayNetConfig: '配置显示屏网络参数',
    viewDisplayAppConfig: '查看显示屏应用参数',
    viewDisplayNetConfig: '查看显示屏网络参数',
    removeDisplayConfigLog: '删除显示屏配置日志',
    editDisplay: '编辑显示屏',
    newDisplay: '新增显示屏',
    removeDisplay: '删除显示屏',
    viewDisplayConfigLog: '查看显示屏配置日志',
    viewGateway: '查看网关',
    editGateway: '编辑网关',
    applyGatewayNetConfig: '配置网关网络参数',
    viewGatewayNetConfig: '查看网关网络参数',
    viewGatewayConfigLog: '查看网关配置日志',
    removeGatewayConfigLog: '删除网关配置日志',
    newGateway: '新增网关',
    viewGatewayHeartbreak: '查看网关心跳',
    removeGateway: '删除网关',
    viewSensor: '查看传感器',
    editSensor: '编辑传感器',
    applySensorAppConfig: '配置传感器应用参数',
    applySensorNetConfig: '配置传感器网络参数',
    viewSensorAppConfig: '查看传感器应用参数',
    viewSensorNetConfig: '查看传感器网络参数',
    viewSensorConfigLog: '查看传感器配置日志',
    removeSensorConfigLog: '删除传感器配置日志',
    newSensor: '新增传感器',
    removeSensor: '删除传感器',
    viewAlarmTrigger: '查看报警触发器',
    newAlarmTrigger: '新增报警触发器',
    editAlarmTrigger: '编辑报警触发器',
    deleteAlarmTrigger: '删除报警触发器',
    viewRelay: '查看中继',
    editRelay: '编辑中继',
    applyRelayNetConfig: '配置中继网络参数',
    viewRelayNetConfig: '查看中继网络参数',
    viewRelayConfigLog: '查看中继配置日志',
    removeRelayConfigLog: '删除中继配置日志',
    newRelay: '新增中继',
    removeRrelay: '删除中继',
    // ---------- 2022 06 30 --------------------
    editCarrierType: '编辑资产类型',
    newCarrierType: '新增资产类型',
    viewCarrierType: '查看资产类型',
    removeCarrierType: '删除资产类型',

    editDeviceType: '编辑探测设备类型',
    newDeviceType: '新增探测设备类型',
    viewDeviceType: '查看探测设备类型',
    removeDeviceType: '删除探测设备类型',

    editDetectionTask: '编辑检测任务',
    newDetectionTask: '新增检测任务',
    viewDetectionTask: '查看检测任务',
    deleteDetectionTask: '删除检测任务',
    triggerDetectionTask: '触发器检测任务',
    // ---------- 2022 06 30 --------------------
    viewDeviceRealTime: '查看设备实时情况',
    newDeviceRealTime: '新增设备实时情况',
    saveDeviceDataAnalyse: '保存设备数据分析',
    viewDeviceDataAnalyse: '查看设备数据分析',
    saveMonitorPointRealTime: '保存设备资产实时情况',
    viewMonitorPointRealTime: '查看设备资产实时情况',
    viewMonitorAnalysis: '查看设备资产数据分析',
    saveMonitorAnalysis: '保存设备资产实时情况',
    viewMapTrack: '查看地图',

    // 2023 07 05
    viewAlarmSwitchLog: '查看报警开关日志',
    editAlarmSwitchLog: '编辑报警开关日志',
    deleteAlarmSwitchLog: '删除报警开关日志',

    // 2023 09 07
    viewPlinth: '查看底座',
    removePlinth: '删除底座',
    editPlinth: '编辑底座',
    editPlinthBind: '绑定底座',
    newPlinth: '新增底座',
    viewPlinthBind: '查看底座绑定历史',

    viewWorkOrder: '查看工单',
    addWorkOrder: '添加工单',
    editWorkOrder: '编辑工单',
    deleteWorkOrder: '删除工单',
    viewWorkSet: '查看工单设置',

    editRecordPointSet: '编辑记录点设置',
    removeBorrow: '解除借调',
    viewBorrow: '查看借调',
    viewDetailData: '查看详细数据',
    viewAlarmRecord: '查看报警记录',
    deleteAlarmRecord: '删除报警记录',
    viewDownloadRecord: '查看下载记录',
    deleteDownloadRecord: '删除下载记录',
    userLogin: '登录',
    userLogout: '登出',

    // 2023-11-14
    viewWarehouse: '查看仓库',
    newWarehouse: '新增仓库',
    editWarehouse: '编辑仓库',
    relatedWarehouse: '探测设备关联仓库',
    removeWarehouse: '删除仓库',
    viewWarehouseOperate: '查看仓库操作记录',
    removeWarehouseOperate: '删除仓库操作记录',
    viewWarehouseCollect: '查看仓库数据采集设置',
    applyWarehouseCollect: '应用仓库数据采集设置',
    removeWarehouseCollect: '删除仓库数据采集设置',

    // 2024-02-26
    viewStore: '查看店铺',
    newStore: '新增店铺',
    editStore: '编辑店铺',
    relatedStore: '探测设备关联店铺',
    removeStore: '删除店铺',
    viewStoreOperate: '查看店铺操作记录',
    removeStoreOperate: '删除店铺操作记录',
    viewStoreCollect: '查看店铺数据采集设置',
    applyStoreCollect: '应用店铺数据采集设置',
    removeStoreCollect: '删除店铺数据采集设置',

    // 2024-04-10
    viewGatewayAlarmNetConfig: '查看二代网关报警参数',
    applyGatewayAlarmNetConfig: '配置二代网关报警参数',
    viewGatewayAndroidNetConfig: '查看二代网络参数',
    applyGatewayAndroidNetConfig: '配置二代网络参数',

    // 2024-11-11 其他监测点
    viewOther: '查看其他',
    editOther: '编辑其他',
    newOther: '新增其他',
    relatedOther: '探测设备关联其他',
    removeOther: '删除其他',
    viewOtherOperate: '查看其他操作记录',
    removeOtherOperate: '删除其他操作记录',
    viewOtherCollect: '查看其他数据采集设置',
    applyOtherCollect: '应用其他数据采集设置',
    removeOtherCollect: '删除其他数据采集设置',

    // 2024-11-16 声光报警 GPS定位
    applySensorGpsConfig: '保存GPS配置',
    viewSensorGpsConfig: '查看GPS配置',
    applySensorAlarmConfig: '保存声光报警配置',
    viewSensorAlarmConfig: '查看声光报警配置',

    viewSensorCalibration: '查看传感器校准信息',
    saveSensorCalibration: '配置传感器校准',

    viewOverviewDevice: '查看设备总览',
    viewOverviewCarrier: '查看资产总览',
    viewOverviewAlarm: '查看报警总览',
    viewOverviewEx: '查看异常总览',

    viewGas: '查看气体',
    newGas: '新增气体',
    editGas: '编辑气体',
    removeGas: '删除气体',
    viewGasAppConfig: '查看气体应用参数',
    applyGasAppConfig: '配置气体应用参数',
    viewGasCalibration: '查看气体校准信息',
    saveGasCalibration: '配置气体校准',
    viewGasConfigLog: '查看气体配置日志',
    removeGasConfigLog: '删除气体配置日志',

    viewMagentism: '查看门磁',
    newMagentism: '新增门磁',
    editMagentism: '编辑门磁',
    removeMagentism: '删除门磁',
    viewMagentismAppConfig: '查看门磁应用参数',
    applyMagentismAppConfig: '配置门磁应用参数',
    viewMagnetismCalibration: '查看门磁校准信息',
    saveMagnetismCalibration: '配置门磁校准',
    viewMagentismConfigLog: '查看门磁配置日志',
    removeMagentismConfigLog: '删除门磁配置日志',

    viewVerifyTask: '查看验证任务',
    addVerifyTask: '新增验证任务',
    updateVerifyTask: '更新验证任务',
    removeVerifyTask: '删除验证任务',
    removeVerifyTaskHis: '删除验证任务历史',
    viewVerifyTaskHis: '查看验证任务历史',
    downloadVerifyTask: '下载验证任务历史',

    viewExportTask: '查看导出任务',
    addExportTask: '新增导出任务',
    updateExportTask: '更新导出任务',
    removeExportTask: '删除导出任务',
    viewExportTaskHis: '查看导出任务历史',
    removeExportTaskHis: '删除导出任务历史',

    viewDataStatistics: '查看数据统计',
    eportDataStatistics: '导出数据统计',
    saveDataStatistics: '保存数据统计',

    viewExRule: '查看无效规则',
    newExRule: '新增无效规则',
    updateExRule: '更新无效规则',
    removeExRule: '删除无效规则',

  }
}
